import React, { useState, FC } from 'react'
import axios from 'ps-components/lib/apiClient';
import { useToast } from 'ps-shared-ui/v4/Toast';
import { Button, Input } from '../../../../../../ps-aspect-design';
import { TOAST_SUCCESS_OPTIONS, TOAST_ERROR_OPTIONS } from '../../../../../../constants';
import './UpdatePrimarySubsite.scss'
import { UserI } from '../../types';

interface UpdatePrimarySubsitePropsI {
    user: UserI
    setUser: (user: UserI) => void
}

const UpdatePrimarySubsite: FC<UpdatePrimarySubsitePropsI> = ({ user, setUser }) => {
    const [newSubsite, setNewSubsite] = useState('')
    const toast = useToast()

    const saveNewSubsite = async () => {
        try {
            const response = await axios.apiPut(`/api/marketpay-internal/users/subsite`, { userId: user?.userId, newSubsite })
            if (response.data.success) {
                setUser({ ...user, primarySubsite: newSubsite } as UserI)
                setNewSubsite('')
            }
            toast(response.data.message, response.data.success ? TOAST_SUCCESS_OPTIONS : TOAST_ERROR_OPTIONS)
        } catch (error) {
            toast(error, TOAST_ERROR_OPTIONS)
        }
    }

    return (
        <>
            { user &&
            <>
                <div className='new_subsite__container'>
                    <div><strong className='new_subsite__label'>New Primary Subsite:</strong></div>
                    <Input onChange={e => setNewSubsite(e.target.value)} value={newSubsite} />
                    <Button disabled={!newSubsite.length} onClick={saveNewSubsite}>Save</Button>
                </div>
            </>
            }
        </>
    )
}

export default UpdatePrimarySubsite